<script lang="ts">
import { defineComponent } from 'vue'
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment/moment'
import { parseTime } from '@/utils/ruoyi'
import { pageDiscoveryComment } from '@/api/discovery/discoveryComment'

export default defineComponent({
  name: 'DiscoveryCommentTable',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        parentId: undefined,
        postId: undefined,
        postTitle: undefined,
        commentUserId: undefined,
        commentUserAvatar: undefined,
        commentUserNickname: undefined,
        content: undefined,
        isAuthorComment: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('回复ID'),
          dataIndex: 'id',
          width: '120px',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('评论内容'),
          dataIndex: 'parentContent',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'parentContent' }
        },
        {
          title: this.$t('回复内容'),
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('回复人'),
          dataIndex: 'commentUserNickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否作者回复'),
          dataIndex: 'isAuthorComment',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isAuthorComment' }
        },
        {
          title: this.$t('评论时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ],
      opened: false,
      parentId: undefined
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    openDrawer(parentId, parentContent) {
      this.parentId = parentId
      this.parentContent = parentContent
      this.opened = true
      this.resetQuery()
      this.handleQuery()
    },
    handleClose() {
      this.opened = false
    },
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询发现板块-评论记录列表 */
    getList() {
      this.loading = true
      this.queryParam.parentId = this.parentId
      pageDiscoveryComment(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        parentId: undefined,
        postId: undefined,
        commentUserId: undefined,
        commentUserAvatar: undefined,
        commentUserName: undefined,
        content: undefined,
        isAuthorComment: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
})
</script>

<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="opened" @cancel="handleClose" @close="handleClose">
    <a-divider orientation="left">
      <b>{{ $t('选择帖子') }}</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="">
          <a-row :gutter="14">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('回复人')" prop="commentUserNickname">
                <a-input v-model="queryParam.commentUserNickname" :maxLength="32" :placeholder="$t('请输入')+$t('回复人')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否作者回复')" prop="isAuthorComment">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.isAuthorComment" allowClear>
                  <a-select-option :value="false">{{$t('否')}}</a-select-option>
                  <a-select-option :value="true">{{$t('是')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('回复开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('回复结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['discovery:discoverycomment:remove']">
          <a-icon type="delete" />
          {{ $t('删除') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%' }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isAuthorComment" slot-scope="text, record">
          {{ record.isAuthorComment ? $t('是') : $t('否') }}
        </span>
        <span slot="parentContent" slot-scope="text, record">
          {{ parentContent }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleClose">
          {{ $t('返回') }}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<style scoped lang="less">
</style>